
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;
        let url = '';
        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }
        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }
        return url + relativeUrl;
      }
import * as __SNOWPACK_ENV__ from '../_snowpack/env.js';
({ url: getAbsoluteUrl('dist/index.js'), env: __SNOWPACK_ENV__ }).env = __SNOWPACK_ENV__;

import React from '../_snowpack/pkg/react.js';
import ReactDOM from '../_snowpack/pkg/react-dom.js';
import * as Sentry from '../_snowpack/pkg/@sentry/browser.js';
import './global.css';
import config from './app-config.js';
import gtm from './gtm.js';
import App from './application/index.js'; // Remove some bogus hash from AWS

(function removeBogusHash() {
  if (window.location.hash === '#_=_') {
    window.history.replaceState('', document.title, window.location.pathname + window.location.search);
  }
})(); // Use custom referrer override in the url (?r=mydomain)


(function useCustomReferrer() {
  const url = new URL(window.location.href);
  const customReferrer = url.searchParams.get('r');

  if (customReferrer) {
    gtm.setCustomReferrer(customReferrer); // Remove the referrer from the search

    url.searchParams.delete('r');
    window.history.replaceState('', document.title, url.toString());
  }
})(); // Do tracking and error reporting only in dev and prod


if (['pim-dev.crystallize.digital', 'pim.crystallize.com'].includes(location.hostname)) {
  Sentry.init({
    dsn: 'https://a001145c9df74531a47125431d0ff942@sentry.io/1551075',
    environment: config.ENVIRONMENT
  }); // Google Tag Manager

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-P47WSWH');
}

ReactDOM.render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(App, null)), document.getElementById('root')); // Bleed React and ReactDOM to window for GraphiQL

window.React = React;
window.ReactDOM = ReactDOM; // Add GraphiQL from CDN

setTimeout(function addGraphiQL() {
  if (!window.__graphiql_added) {
    const graphiQLScript = document.createElement('script');
    graphiQLScript.crossOrigin = true;
    graphiQLScript.src = 'https://unpkg.com/graphiql@1.5.7/graphiql.min.js';
    document.head.appendChild(graphiQLScript);
    const graphiQLStyles = document.createElement('link');
    graphiQLStyles.href = 'https://unpkg.com/graphiql@1.5.7/graphiql.min.css';
    graphiQLStyles.rel = 'stylesheet';
    document.head.appendChild(graphiQLStyles);
    window.window.__graphiql_added = true;
  }
}, 100); // Hot Module Replacement (HMR) - Remove this snippet to remove HMR.
// Learn more: https://www.snowpack.dev/#hot-module-replacement

if (undefined /* [snowpack] ({ url: getAbsoluteUrl('dist/index.js'), env: __SNOWPACK_ENV__ }).hot */ ) {
  undefined /* [snowpack] ({ url: getAbsoluteUrl('dist/index.js'), env: __SNOWPACK_ENV__ }).hot */ .accept();
}